<template>
    <div class="main items-center">
        <div>
            <h2 class="mb-3">Oops!</h2>
            <p>This profile is locked or it was removed!</p>
        </div>
        <div class="my-base">
            <img src="@/assets/images/icons/editor-icons/locked-profile.svg" alt="">
        </div>
        <div>
            <vs-button color="dark" icon-pack="feather" icon="icon-arrow-up-right" icon-after to="/user/dashboard">Visit Dashboard</vs-button>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
.main {
    background: #F1F3F5;
    height: 100vh;
    padding-top: 100px;
}

h2 {
    font-weight: 900;
    font-size: 64px;
    line-height: 96px;
    color: #1B1B1B;
}

p {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    color: #696F79;
}
</style>